import { useMemo } from 'react';
import { usePageType } from '@Hooks/usePageType';
import useResizeLayout from '@Hooks/useResizeLayout';
import { PageTypes } from '@Enum/PageTypes.enum';
import { MButton } from '@Components/Base';
import { ReactComponent as ChatbotIcon } from '@Icons/additional/chatbot.svg';

import styles from './chatbot-button.module.css';

const ChatbotButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { isMobile } = useResizeLayout();
  const pageType = usePageType();
  const bottomMargin = useMemo(() => {
    const pageTypesBottomMargin: Record<string, number> = {
      [PageTypes.DASHBOARD]: 20,
      [PageTypes.MY_REQUESTS]: 100,
      [PageTypes.APPROVALS]: 100,
      [PageTypes.CREATE_MY_REQUEST]: 145,
      [PageTypes.EDIT_MY_REQUEST]: 145,
      [PageTypes.RESPOND_TASK]: 150,
      [PageTypes.PROCUREMENT]: 100,
      [PageTypes.EDIT_PROCUREMENT]: 170,
      [PageTypes.CREATE_PROCUREMENT]: 170,
    };

    return (pageType && pageTypesBottomMargin[pageType]) || 20;
  }, [pageType]);

  return (
    <MButton
      type="primary"
      className={styles.button}
      onClick={onClick}
      style={{ bottom: isMobile ? bottomMargin : 5 }}
    >
      <ChatbotIcon />
    </MButton>
  );
};

export default ChatbotButton;
